import React from 'react';
import { motion } from 'framer-motion';
import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

const PathwayContainer = styled(Box)(({ theme }) => ({
  position: 'fixed',
  bottom: theme.spacing(8),
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  gap: theme.spacing(4),
  zIndex: 2,
}));

const PathwayButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(2, 4),
  background: 'rgba(26, 26, 46, 0.6)',
  backdropFilter: 'blur(5px)',
  border: '1px solid rgba(138, 43, 226, 0.2)',
  borderRadius: theme.spacing(1),
  color: theme.palette.common.white,
  position: 'relative',
  overflow: 'hidden',
  transition: 'all 0.3s ease',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '-50%',
    left: '-50%',
    width: '200%',
    height: '200%',
    background: 'linear-gradient(0deg, transparent, transparent 30%, rgba(138, 43, 226, 0.3))',
    transform: 'rotate(-45deg)',
    transition: 'all 0.5s ease',
    opacity: 0,
  },
  '&:hover': {
    background: 'rgba(26, 26, 46, 0.8)',
    transform: 'scale(1.05)',
    boxShadow: '0 0 20px rgba(138, 43, 226, 0.5)',
    '&::before': {
      opacity: 1,
      transform: 'rotate(-45deg) translateY(100%)',
    },
  }
}));

const NavigationPathways: React.FC = () => {
  const navigate = useNavigate();

  const pathways = [
    { name: 'Explore Marketplace', path: '/marketplace' },
    { name: 'View Dashboard', path: '/dashboard' },
    { name: 'Browse Solutions', path: '/solutions' },
    { name: 'Submit Proposal', path: '/submit-proposal' },
  ];

  return (
    <PathwayContainer>
      {pathways.map((pathway, index) => (
        <motion.div
          key={pathway.path}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.2 }}
        >
          <PathwayButton
            onClick={() => navigate(pathway.path)}
            variant="text"
          >
            {pathway.name}
          </PathwayButton>
        </motion.div>
      ))}
    </PathwayContainer>
  );
};

export default NavigationPathways; 